var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsMsEventsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.1 29.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 1.6px;\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.9,20.1H4.2c-1.7,0-3.1-1.4-3.1-3.1V6.2c0-1.7,1.4-3.1,3.1-3.1h10.8c1.7,0,3.1,1.4,3.1,3.1v10.8c0,1.7-1.4,3.1-3.1,3.1h-.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18,
    y1: 8.7,
    x2: 1.1,
    y2: 8.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5.1,
    y1: 1.1,
    x2: 5.1,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.9,
    y1: 1.1,
    x2: 13.9,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.4,
    y: 12.1,
    width: 4.3,
    height: 4.3,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.1,28.8s0,0,0,0,0,0,0,0c0,0-.1,0-.2,0s-.2,0-.3,0-.2,0-.3,0-.1,0-.2,0,0,0,0,0c0,0,0,0,0,0v-4.9h0l-1.7,4.8s0,0,0,0,0,0-.1,0-.1,0-.2,0-.2,0-.3,0-.2,0-.3,0-.1,0-.2,0c0,0,0,0-.1,0,0,0,0,0,0,0l-1.7-4.8h0v4.9s0,0,0,0,0,0,0,0c0,0-.1,0-.2,0,0,0-.2,0-.3,0s-.2,0-.3,0-.1,0-.2,0,0,0,0,0c0,0,0,0,0,0v-5.3c0-.2,0-.3.1-.4,0,0,.2-.1.3-.1h.8c.1,0,.3,0,.4,0,0,0,.2,0,.3.1,0,0,.1.1.2.2s0,.2.1.3l1.3,3.6h0l1.3-3.5c0-.1,0-.2.1-.3,0,0,.1-.2.2-.2,0,0,.1,0,.2-.1,0,0,.2,0,.3,0h.8c0,0,.2,0,.2,0,0,0,.1,0,.1,0s0,0,0,.2c0,0,0,.1,0,.2v5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.9,27.2c0,.3,0,.6-.2.8s-.3.4-.5.6c-.2.2-.4.3-.7.4-.3,0-.6.1-.9.1s-.4,0-.6,0-.3,0-.5-.1-.3,0-.3-.2-.2,0-.2-.1c0,0,0,0,0-.2s0-.2,0-.3,0-.2,0-.2c0,0,0-.1,0-.2s0,0,0,0c0,0,0,0,0,0s.1,0,.2,0c0,0,.2.1.3.2s.3.1.4.2c.2,0,.4,0,.6,0s.3,0,.4,0,.2,0,.3-.2.1-.1.2-.2,0-.2,0-.3,0-.3-.1-.3c0,0-.2-.2-.3-.3-.1,0-.3-.1-.4-.2s-.3-.1-.5-.2c-.2,0-.3-.2-.5-.3s-.3-.2-.4-.3-.2-.3-.3-.5-.1-.4-.1-.6,0-.5.2-.8.3-.4.4-.5.4-.3.6-.3c.2,0,.5-.1.8-.1s.3,0,.4,0c.1,0,.3,0,.4,0s.2,0,.3.1.2,0,.2.1c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,.1v.2c0,0,0,.2,0,.2,0,0,0,.1,0,.2s0,0,0,0,0,0,0,0,0,0-.2,0-.2,0-.3-.1c-.1,0-.2,0-.4-.1-.1,0-.3,0-.5,0s-.2,0-.3,0-.2,0-.2.1-.1.1-.1.2c0,0,0,.2,0,.3,0,.1,0,.2.1.3s.2.2.3.3.3.1.4.2.3.1.5.2c.2,0,.3.2.5.3.2,0,.3.2.4.3s.2.3.3.5.1.4.1.6h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMsEventsWhite);
export default __webpack_public_path__ + "static/media/Icons_MS_Events_White.d425a22a5e1569a882e622b043c13ad7.svg";
export { ForwardRef as ReactComponent };